export abstract class PostEffectBase {
    protected _postEffect: pc.PostEffect;
    protected _active: boolean;

    get gd(): pc.GraphicsDevice { return this._gd; }
    protected _gd: pc.GraphicsDevice;

    get camera(): pc.CameraComponent { return this._camera; }
    protected _camera: pc.CameraComponent;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(gd: pc.GraphicsDevice, camera: pc.CameraComponent) {
        this._gd = gd;
        this._camera = camera;
        this._active = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected _start(): void {
        if (!this._active) {
            this._active = true;
            this._camera.postEffects.addEffect(this._postEffect);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        if (this._active) {
            this._active = false;
            this._camera.postEffects.removeEffect(this._postEffect);
        }
    }
}